/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandAdminDto } from '../models/BrandAdminDto';
import type { Language } from '../models/Language';
import type { ListOf1OfBrandClientDto } from '../models/ListOf1OfBrandClientDto';
import type { Pagination1OfBrandMiniDto } from '../models/Pagination1OfBrandMiniDto';
import type { PostBrandRequestAdmin } from '../models/PostBrandRequestAdmin';
import type { PutBrandRequestAdmin } from '../models/PutBrandRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandsService {
    /**
     * @returns ListOf1OfBrandClientDto OK
     * @throws ApiError
     */
    public static getBrandsClient({
        name,
    }: {
        name?: string,
    }): CancelablePromise<ListOf1OfBrandClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/brands',
            query: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ListOf1OfBrandClientDto OK
     * @throws ApiError
     */
    public static getPublicBrandsClient({
        name,
        language,
    }: {
        name?: string,
        language?: Language,
    }): CancelablePromise<ListOf1OfBrandClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/brands/public',
            query: {
                'name': name,
                'language': language,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBrandDetails`
     * @returns BrandAdminDto OK
     * @throws ApiError
     */
    public static getBrandAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<BrandAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/brands/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBrand`
     * @returns BrandAdminDto OK
     * @throws ApiError
     */
    public static putBrandAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBrandRequestAdmin,
    }): CancelablePromise<BrandAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/brands/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteBrand`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteBrandAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/brands/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBrands`
     * @returns Pagination1OfBrandMiniDto OK
     * @throws ApiError
     */
    public static getBrandsAdmin({
        id,
        name,
        searchWord,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        name?: string,
        searchWord?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfBrandMiniDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/brands',
            query: {
                'id': id,
                'name': name,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBrand`
     * @returns BrandAdminDto OK
     * @throws ApiError
     */
    public static postBrandAdmin({
        requestBody,
    }: {
        requestBody?: PostBrandRequestAdmin,
    }): CancelablePromise<BrandAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/brands',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
